"use strict";

require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRadioGroup = require("react-radio-group");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("@evidation/form-elements/lib/components/Button"));
var _constants = require("./constants");
var _qoltech = _interopRequireDefault(require("../../assets/qoltech.png"));
var _validations = _interopRequireDefault(require("./validations"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var TitleContainer = _styledComponents["default"].div.withConfig({
  displayName: "ACQ5__TitleContainer"
})(["h3{text-align:center;}.copyright{margin-top:10%;p{display:inline-block;}p.copy{width:5%;vertical-align:top;text-align:center;}p.text{width:95%;}}"]);
var PageContainer = _styledComponents["default"].div.withConfig({
  displayName: "ACQ5__PageContainer"
})(["h3{text-transform:uppercase;margin-bottom:20px !important;}.question-title{margin-bottom:10px;}"]);
var Buttons = _styledComponents["default"].div.withConfig({
  displayName: "ACQ5__Buttons"
})(["display:grid;grid-template-columns:1fr 1fr;grid-template-areas:'back next';grid-gap:20px;text-transform:uppercase;margin-top:50px;.back{grid-area:back;}.next{grid-area:next;}"]);
var RadioContainer = _styledComponents["default"].label.withConfig({
  displayName: "ACQ5__RadioContainer"
})(["width:100%;display:flex;align-items:center;cursor:pointer;padding:10px;border-top:1px solid #eee;input[type='radio']{width:auto;position:relative;opacity:1;cursor:inherit;margin:0 10px 0 0;}.label{flex:1 1 auto;}"]);
var SummaryContainer = _styledComponents["default"].div.withConfig({
  displayName: "ACQ5__SummaryContainer"
})([".header{margin-bottom:20px;}.entry{padding:10px;border-top:1px solid #eee;cursor:pointer;&:hover{background-color:#f3f3f3;}.question{font-weight:bold;}}"]);
var CopyRightBanner = _styledComponents["default"].span.withConfig({
  displayName: "ACQ5__CopyRightBanner"
})(["position:absolute;bottom:0;"]);
var TrademarkImage = _styledComponents["default"].img.withConfig({
  displayName: "ACQ5__TrademarkImage"
})(["width:100px;display:block;margin:0 auto;"]);
var Title = function Title() {
  return /*#__PURE__*/_react["default"].createElement(TitleContainer, null, /*#__PURE__*/_react["default"].createElement("h3", null, _constants.TEXT.titlePage.title), /*#__PURE__*/_react["default"].createElement("h3", null, _constants.TEXT.titlePage.subtitle), /*#__PURE__*/_react["default"].createElement(TrademarkImage, {
    src: _qoltech["default"]
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "class": "copyright"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    "class": "copy"
  }, "\xA9"), /*#__PURE__*/_react["default"].createElement("p", {
    "class": "text"
  }, _constants.TEXT.titlePage.copyright)));
};
var Description = function Description() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, _constants.TEXT.descriptionPage.title), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, _constants.TEXT.descriptionPage.description.select), ' ', _constants.TEXT.descriptionPage.description.instruction));
};
var Summary = function Summary(_ref) {
  var values = _ref.values,
    _onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(SummaryContainer, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "header"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, _constants.TEXT.summaryPage.title), /*#__PURE__*/_react["default"].createElement("p", null, _constants.TEXT.summaryPage.subtitle)), values.map(function (value, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "entry",
      onClick: function onClick() {
        return _onClick(index);
      },
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "question"
    }, _constants.QUESTIONS[index]), /*#__PURE__*/_react["default"].createElement("div", {
      className: "answer"
    }, _constants.ANSWERS[index][value]));
  }));
};
var Final = function Final() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, _constants.TEXT.finalPage.title), /*#__PURE__*/_react["default"].createElement("p", null, _constants.TEXT.finalPage.internet, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://eprovide.mapi-trust.org",
    target: "_blank"
  }, "https://eprovide.mapi-trust.org")));
};

/**
 * Generic component to wrap every "page" in this flow, in order to make
 * the layout and back/forward navigation consistent.
 */
var Page = function Page(_ref2) {
  var children = _ref2.children,
    onBack = _ref2.onBack,
    onNext = _ref2.onNext,
    _ref2$hideNext = _ref2.hideNext,
    hideNext = _ref2$hideNext === void 0 ? false : _ref2$hideNext;
  return /*#__PURE__*/_react["default"].createElement(PageContainer, null, children, /*#__PURE__*/_react["default"].createElement(Buttons, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "back"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return onBack();
    },
    disabled: !onBack,
    buttonStyle: "achievement"
  }, _constants.TEXT.buttons.back)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "next"
  }, !hideNext && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return onNext();
    },
    disabled: !onNext,
    buttonStyle: "achievement"
  }, _constants.TEXT.buttons.next))));
};
var Question = function Question(_ref3) {
  var description = _ref3.description,
    answerLabels = _ref3.answerLabels,
    _ref3$value = _ref3.value,
    value = _ref3$value === void 0 ? null : _ref3$value,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    onChange = _ref3.onChange;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "question-title"
  }, description), /*#__PURE__*/_react["default"].createElement(_reactRadioGroup.RadioGroup, {
    selectedValue: value
  }, answerLabels.map(function (answerLabel, answerIndex) {
    return /*#__PURE__*/_react["default"].createElement(RadioContainer, {
      onClick: function onClick(e) {
        if (disabled) return;
        e.preventDefault();
        onChange(answerIndex);
      },
      key: answerIndex
    }, /*#__PURE__*/_react["default"].createElement(_reactRadioGroup.Radio, {
      value: answerIndex,
      disabled: disabled
      // To supress React's warning.
      ,
      onChange: function onChange() {}
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "label"
    }, answerLabel));
  })));
};
var ACQ5 = function ACQ5(_ref4) {
  var _ref4$input = _ref4.input,
    onChange = _ref4$input.onChange,
    name = _ref4$input.name,
    disabled = _ref4.disabled;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isComplete = _useState2[0],
    setIsComplete = _useState2[1];
  var _useState3 = (0, _react.useState)(_constants.PAGES.TITLE),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    values = _useState6[0],
    setValues = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    nextPage = _useState8[0],
    setNextPage = _useState8[1];
  var back = function back() {
    if (nextPage !== null) {
      setCurrentPage(nextPage);
      setNextPage(null);
    } else {
      setCurrentPage(function (currentPage) {
        return currentPage - 1;
      });
    }
  };
  var next = function next() {
    if (nextPage !== null) {
      setCurrentPage(nextPage);
      setNextPage(null);
    } else {
      setCurrentPage(function (currentPage) {
        return currentPage + 1;
      });
    }
  };
  var setValueByQuestionIndex = function setValueByQuestionIndex(index, value) {
    setValues(function (values) {
      values = (0, _toConsumableArray2["default"])(values);
      values[index] = value;
      return values;
    });
  };

  // Once we hit the final page, mark the survey as complete.
  (0, _react.useEffect)(function () {
    if (!isComplete && currentPage === _constants.PAGES.FINAL) {
      setIsComplete(true);
    }
  }, [isComplete, currentPage]);

  // Fire `onChange` when the `values` array changes, but only once the
  // entire survey has been completed.
  (0, _react.useEffect)(function () {
    if (!isComplete) return;
    var average = values.reduce(function (sum, value) {
      return sum + value;
    }, 0) / values.length;
    var changeObj = (0, _defineProperty2["default"])({}, name, average);
    values.forEach(function (value, questionIndex) {
      changeObj["".concat(name, "_").concat(questionIndex + 1)] = value;
    });
    onChange(changeObj);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isComplete, values]);
  var makeQuestion = function makeQuestion(questionIndex) {
    return /*#__PURE__*/_react["default"].createElement(Page, {
      onBack: back
    }, /*#__PURE__*/_react["default"].createElement(Question, {
      description: _constants.QUESTIONS[questionIndex],
      answerLabels: _constants.ANSWERS[questionIndex],
      value: values[questionIndex],
      disabled: disabled,
      onChange: function onChange(value) {
        setValueByQuestionIndex(questionIndex, value);
        next();
      }
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, currentPage === _constants.PAGES.TITLE ? /*#__PURE__*/_react["default"].createElement(Page, {
    onNext: next
  }, /*#__PURE__*/_react["default"].createElement(Title, null)) : currentPage === _constants.PAGES.DESCRIPTION ? /*#__PURE__*/_react["default"].createElement(Page, {
    onBack: back,
    onNext: next
  }, /*#__PURE__*/_react["default"].createElement(Description, null)) : currentPage >= _constants.PAGES.QUESTION_1 && currentPage <= _constants.PAGES.QUESTION_5 ? makeQuestion(currentPage - _constants.PAGES.QUESTION_1) : currentPage === _constants.PAGES.SUMMARY ? /*#__PURE__*/_react["default"].createElement(Page, {
    onBack: back,
    onNext: next
  }, /*#__PURE__*/_react["default"].createElement(Summary, {
    values: values,
    onClick: function onClick(index) {
      setNextPage(_constants.PAGES.SUMMARY);
      setCurrentPage(_constants.PAGES.QUESTION_1 + index);
    }
  })) : currentPage === _constants.PAGES.FINAL ? /*#__PURE__*/_react["default"].createElement(Page, {
    onBack: back,
    hideNext: true
  }, /*#__PURE__*/_react["default"].createElement(Final, null)) : null, /*#__PURE__*/_react["default"].createElement(CopyRightBanner, null, _constants.TEXT.copyrightBanner));
};
var _default = exports["default"] = ACQ5;